<div class="">
<!--  <div class="test-controls">-->
<!--    <p-card>-->
<!--      <ng-template pTemplate="header">-->
<!--        <div class="test-header">-->
<!--          <h3>Payment Plan Test Interface</h3>-->
<!--        </div>-->
<!--      </ng-template>-->

<!--      <ng-template pTemplate="content">-->
<!--        <div class="test-selector">-->
<!--          <label for="dunningIdSelect">Select Test Data Set:</label>-->
<!--          <p-dropdown id="dunningIdSelect"-->
<!--                      [(ngModel)]="selectedDunningId"-->
<!--                      [options]="availableDunningIds"-->
<!--                      (onChange)="onDunningIdChange()"-->
<!--                      placeholder="Select dunning ID"-->
<!--                      [style]="{'width': '200px'}">-->
<!--            <ng-template let-item pTemplate="item">-->
<!--              Dunning ID: {{ item }}-->
<!--            </ng-template>-->
<!--            <ng-template let-item pTemplate="selectedItem">-->
<!--              Dunning ID: {{ item }}-->
<!--            </ng-template>-->
<!--          </p-dropdown>-->
<!--        </div>-->

<!--        <div class="test-info">-->
<!--          <p><strong>Test Data Sets:</strong></p>-->
<!--          <ul>-->
<!--            <li><strong>30001:</strong> Standard scenario (4 contracts, 1 charge) - Example from requirements</li>-->
<!--            <li><strong>30002:</strong> High amounts scenario (3 contracts, 3 charges)</li>-->
<!--            <li><strong>30003:</strong> Simple scenario (2 contracts, 1 charge)</li>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--    </p-card>-->
<!--  </div>-->

  <div class="surface-50 border-round-md">
    <bm-payment-plan [dunningId]="selectedDunningId"></bm-payment-plan>
  </div>
</div>
